import { useEffect, useState } from "react";

import useGraphQLClient from "./useGraphQLClient";
import { READ_KNOWLEDGE_COVERAGE_DASHBOARD } from "../graph/dashboard/queries";


const emptyDashboard = {
  summary: {
    totalAssignments: 0,
    notViewed: 0,
    readOnly: 0,
    understood: 0,
    knowledgeCoveragePercent: 0,
  },
  departmentRows: [],
  userRows: [],
  sopRows: [],
  recentlyUpdatedRows: [],
};

const useKnowledgeCoverageDashboard = ({ tenantId }) => {
  const [data, setData] = useState(emptyDashboard);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const client = useGraphQLClient();

  useEffect(() => {
    if (!tenantId) {
      setData(emptyDashboard);
      setLoading(false);
      setError(null);
      return;
    }

    let isMounted = true;

    const loadDashboard = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await client.request(
          READ_KNOWLEDGE_COVERAGE_DASHBOARD,
          {
            tenantId,
          }
        );

        if (!isMounted) return;

        setData(response?.readKnowledgeCoverageDashboard || emptyDashboard);
      } catch (err) {
        if (!isMounted) return;

        console.error("failed loading knowledge coverage dashboard", err);
        setError(err);
        setData(emptyDashboard);
      } finally {
        if (!isMounted) return;

        setLoading(false);
      }
    };

    loadDashboard();

    return () => {
      isMounted = false;
    };
  }, [tenantId]);

  return {
    data,
    loading,
    error,
  };
};

export default useKnowledgeCoverageDashboard;